import React from 'react';
import Section, { SectionTitle } from './ui/Section';
import TeamMemberCard from './TeamMemberCard';

const TeamSection = ({ title = "Our Team" }) => {
  // Team data
  const teamMembers = [
    {
      name: "Dr. Philip Alton",
      title: "Founder & CEO",
      description: "Former emergency medicine doctor, NHS clinical entrepreneur",
      photoUrl: "/images/team/philip-alton.png"
    },
    {
      name: "Dr. Miguel Hernandez",
      title: "CTO",
      description: "Pioneer in digital signal processing and machine learning",
      photoUrl: "/images/team/miguel-hernandez.png"
    },
    {
      name: "Kieran Dwyer",
      title: "Head of Software",
      description: "Extensive experience in the UK National Health Service",
      photoUrl: "/images/team/kieran-dwyer.png"
    },
    {
      name: "Dr. Sundeep Kaul",
      title: "CMO",
      description: "Over 25 years of experience in respiratory medicine",
      photoUrl: "/images/team/sundeep-kaul.png"
    },
    {
      name: "Andrew Davidson",
      title: "Board Advisor",
      description: "Experienced technology entrepreneur with multiple successful exits",
      photoUrl: "/images/team/andrew-davidson.png"
    },
    {
      name: "Paul Moreton",
      title: "Board Advisor",
      description: "Leader in Global MedTech & HealthTech. Former executive at Pfizer, GE Healthcare, and OCS Group.",
      photoUrl: "/images/team/paul-moreton.png"
    }
  ];

  return (
    <Section id="about">
      <SectionTitle>{title}</SectionTitle>
      
      <div className="flex flex-col lg:flex-row items-start gap-10">
        <div className="lg:w-1/3">
          <p className="text-gray-700 mb-6 leading-relaxed">
            Our team combines deep expertise in medicine, technology, and business to drive 
            our mission of transforming healthcare with AI.
          </p>
          <div className="bg-accent bg-opacity-30 p-6 rounded-lg">
            <p className="italic text-gray-700">
              "We're pioneering a new era in healthcare with our Large Biosignal Model, 
              a revolution that will redefine healthcare as we know it."
            </p>
            <p className="font-medium text-primary mt-2">— Dr. Philip Alton, Founder & CEO</p>
          </div>
        </div>
        
        <div className="lg:w-2/3">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {teamMembers.map((member, index) => (
              <TeamMemberCard
                key={index}
                name={member.name}
                title={member.title}
                description={member.description}
                photoUrl={member.photoUrl}
              />
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default TeamSection;